import { combineReducers } from 'redux';
import { USER_REDUCER_NAME, userReducer } from '@is24at/react-redux';
import { reducer as reduxAsyncConnect } from 'core/reduxAsync';
import { reducer as htmlMeta } from 'components/HtmlMeta/modules/htmlMeta';
import { reducer as runtimeConfig } from 'core/runtimeConfigReducer';
import { reducer as expose } from 'routes/Expose/modules/expose';
import { reducer as resultList } from 'routes/ResultList/modules/resultList';
import { reducer as properties } from 'routes/Expose/components/RealtorProperties/modules/realtorProperties';
import { reducer as contactRequestForm } from 'routes/Expose/modules/form';

export default combineReducers({
  resultList,
  expose,
  properties,
  contactRequestForm,
  htmlMeta,
  reduxAsyncConnect,
  runtimeConfig,
  [USER_REDUCER_NAME]: userReducer,
});
